module.exports = __webpack_public_path__ + "static/male-202869246c2f2b8135cd7cc55f490034.svg";